import React from 'react';
import { Row } from 'reactstrap';
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';
import { useMobile } from '../Layout/UseResponsive';
import { CountersDTO } from '../../models/Counter/CountersDTO';
import { CounterValueDTO } from '../../models/Counter/CounterValueDTO';
import InputComponent from '../InputComponent';
import LoadingSpinner from '../LoadingSpinner';
import '../../styles/AssistanceExecutions.css';

interface RenderEquipmentCountersComponentProps {
  isComplete: boolean;
  counterValues: CounterValueDTO[];
  newCounterValues?: CountersDTO[];
  setNewCounterValues?: (values: CountersDTO[]) => void;
  loadingCounters: boolean;
  errorCounters: string | null;
  hideLastExecutionReading?: boolean; // Hide the last execution reading section
}

export default function RenderEquipmentCountersComponent({ isComplete, counterValues, newCounterValues, setNewCounterValues, loadingCounters, errorCounters, hideLastExecutionReading }: RenderEquipmentCountersComponentProps) {
  const { availableModules } = useAvailableModulesContext();
  const isMobile = useMobile(700);

  const renderMobileCounters = () => {
    return counterValues.map((counterValue, index) => {
      const showLastReading = availableModules.includes('IsActiveErpEquipmentCountersModule') && !hideLastExecutionReading;

      return (
        <div key={counterValue.id} className="counter-card-mobile">
          <div className="counter-card-header">
            <span className="counter-name">{counterValue.name || `Contador ${index + 1}`}</span>
            <span className="counter-unit-badge">{counterValue.unit || '-'}</span>
          </div>

          <div className="counter-readings">
            <div className="counter-reading-item">
              <label className="counter-reading-label">Leitura Atual</label>
              <input
                type="number"
                className="counter-reading-input"
                value={isComplete ? counterValue.value : (newCounterValues?.[index]?.counterValue ?? 0)}
                readOnly={isComplete}
                onFocus={(e) => {
                  if (!isComplete && newCounterValues?.[index]?.counterValue === undefined) {
                    e.target.value = '';
                  }
                }}
                onChange={(e) => {
                  if (!isComplete && newCounterValues && setNewCounterValues) {
                    const newValues = [...newCounterValues];
                    newValues[index].counterValue = e.target.value === '' ? undefined : Number(e.target.value);
                    setNewCounterValues(newValues);
                  }
                }}
              />
            </div>

            {showLastReading && (
              <div className="counter-reading-item">
                <label className="counter-reading-label">Leitura Anterior</label>
                <div className="counter-reading-value">{counterValue.value}</div>
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  const renderCounters = () => {
    return counterValues.map((counterValue, index) => {
      return (

        <React.Fragment key={counterValue.id}>
          <InputComponent
            xl={2}
            lg={2}
            md={2}
            sm={10}
            xs={10}
            style={{ width: "100%" }}
            type={"number"}
            value={isComplete ? counterValue.value : (newCounterValues?.[index]?.counterValue ?? 0)}
            label={`${counterValue.name}` || `Contador ${index + 1}`}
            readOnly={isComplete}
            clearZeroOnFocus={!isComplete}
            onChange={(value) => {
              if (!isComplete && newCounterValues && setNewCounterValues) {
                const newValues = [...newCounterValues];
                newValues[index].counterValue = value === '' ? undefined : (value as number);
                setNewCounterValues(newValues);
              }
            }}
          />
          <InputComponent
            xl={1}
            lg={1}
            md={1}
            sm={2}
            xs={2}
            style={{ width: "100%" }}
            type={"text"}
            value={counterValue.unit || '-'}
            label={"Unidade"}
            readOnly={true}
          />

          {availableModules.includes('IsActiveErpEquipmentCountersModule') && !hideLastExecutionReading && (
            <>
              <InputComponent
                xl={2}
                lg={2}
                md={2}
                sm={10}
                xs={10}
                style={{ width: "100%" }}
                type={"number"}
                value={counterValue.value}
                label={'Leitura Anterior'}
                readOnly={true}
              />
              <InputComponent
                xl={1}
                lg={1}
                md={1}
                sm={2}
                xs={2}
                style={{ width: "100%" }}
                type={"text"}
                value={counterValue.unit || '-'}
                label={"Unidade"}
                readOnly={true}
              />
            </>
          )}
        </React.Fragment>
      );
    });
  };

  return (
    <div>
      {loadingCounters ? (
        <LoadingSpinner />
      ) : errorCounters ? (
        <div className="text-danger">{errorCounters}</div>
      ) : counterValues.length === 0 ? (
        <p>Este equipamento não têm contadores associados.</p>
      ) : isMobile ? (
        <div className="counters-mobile-container">
          {renderMobileCounters()}
        </div>
      ) : (
        <Row>
          {renderCounters()}
        </Row>
      )}
    </div>
  );
}
